import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestsPostRes extends EntityRequest {}
